// Categorical chart palette. Index 0 is the "primary series" color and
// follows the active tenant brand at runtime (read from the --brand-primary
// CSS variable set by _document.js / ThemeProvider). Indices 1-11 are fixed
// categorical accents — those should NOT reskin per tenant because they
// represent distinct data series, not the brand.

const FALLBACK_BRAND = '#009de1'; // default-tenant primary, used during SSR

// Static palette retained as the default export so existing imports keep
// working. Index 0 = the fallback brand color; consumers that want the
// active tenant's brand at index 0 should call getDefaultChartColors() at
// render time.
const defaultChartColors = [
  FALLBACK_BRAND,
  '#5C6BC0', // Indigo
  '#FFB74D', // Amber
  '#4DB6AC', // Teal
  '#FF7043', // Deep Orange
  '#AB47BC', // Purple
  '#FF8A65', // Light Orange
  '#F06292', // Pink
  '#64B5F6', // Light Blue
  '#4CAF50', // Green
  '#FFD54F', // Yellow
  '#9E9D24', // Lime
];

function resolveBrandPrimary() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return FALLBACK_BRAND;
  }
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue('--brand-primary')
    .trim();
  return value || FALLBACK_BRAND;
}

// Returns a fresh array with index 0 replaced by the active tenant brand.
// Use this from chart wrappers (BarChart, PieChart) so the primary series
// reskins per tenant without forcing every chart caller to plumb a color
// through props.
export function getDefaultChartColors() {
  return [resolveBrandPrimary(), ...defaultChartColors.slice(1)];
}

export default defaultChartColors;
